import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
/** Helper method to construct a url w/ tracking parameters
 *
 * @param                    Object
 *  @key url                 string  base link
 *  @key trkElement          string  TrkElement from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkPageType         string  TrkPageType from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkLocation         string  slug representing the location of the referrer
 *  @key trkSectionCategory  string  slug representing the page section context of the referrer
 *  @key trkTaxonomy         Object  window.nwPageTaxonomy obj
 *
 * @return                string  url w/ tracking data as query params
 */

export var buildLink = function buildLink(_ref) {
  var _baseParams;

  var navigationSourceImpressionId = _ref.navigationSourceImpressionId,
      url = _ref.url,
      trkElement = _ref.trkElement,
      trkPageType = _ref.trkPageType,
      trkLocation = _ref.trkLocation,
      trkSectionCategory = _ref.trkSectionCategory,
      trkTaxonomy = _ref.trkTaxonomy;
  var baseParams = (_baseParams = {}, _defineProperty(_baseParams, TrkTag.location, trkLocation), _defineProperty(_baseParams, TrkTag.element, trkElement), _defineProperty(_baseParams, TrkTag.pageType, trkPageType), _defineProperty(_baseParams, TrkTag.sectionCategory, trkSectionCategory), _baseParams);
  var params = navigationSourceImpressionId ? _objectSpread(_objectSpread({}, baseParams), {}, {
    navigation_source_impression_id: navigationSourceImpressionId
  }) : baseParams;
  return setTrk({
    url: url,
    taxonomy: trkTaxonomy,
    params: params
  });
};